import React, { useEffect } from "react";
import TextPopup from "./TextPopup";
import LiveSoundDisplay from "./LiveSoundDisplay";
import AnimationPopup from "./AnimationPopup";
import RankingPopup from "./RankingPopup";
import PreRankingPopup from "./PreRankingPopup";
import type { PopupType } from "../types";
import LiveSoundRecord from "./LiveSoundRecord";
import ScoreRevelation from "./ScoreRevealation";
import { useStoredDecibelAverage } from "../hooks/useStoredDecibelAverage";

import { useParams } from "react-router-dom";
import useSonometerScreenPolling from "../hooks/useSonometerScreenPolling"; // Import the new hook
import { ChampionshipService } from "services/championship.service";
import { useMemo } from "react";

const DisplayPage: React.FC = () => {
  const { sonometerId } = useParams<{ sonometerId: string }>();

  //const { data: sonometer } = useGetSonometerQuery(sonometerId!)
  const {
    screen: activeView,
    loading,
    error,
    sonometerFromServer: sonometer,
  } = useSonometerScreenPolling(sonometerId!);
  const { storedAverage, maxAverage } = useStoredDecibelAverage();
  void loading;
  console.log("max average", maxAverage);

  const championshipService = useMemo(() => new ChampionshipService(), []);
  useEffect(() => {
    const fetchChampionship = async () => {
      if (sonometer?.championshipId) {
        try {
          const championshipData =
            await championshipService.fetchChampionshipData(
              sonometer.championshipId
            );
          if (championshipData && championshipData.maxScore) {
            localStorage.setItem(
              `championshipMaxScore-${sonometer.championshipId}`,
              championshipData.maxScore?.toString()
            );
          }
        } catch (error) {
          console.error("Error fetching championship data:", error);
        }
      }
    };

    fetchChampionship();
  }, [sonometer, championshipService]);

  // No socket connection needed anymore, remove useEffect
  useEffect(() => {
    if (error) {
      console.error("🚨 [DISPLAY] Sonometer screen polling error:", error);
    }
  }, [error]);

  const views: Record<PopupType, JSX.Element> = {
    texte1: <TextPopup type="texte1" sonometer={sonometer!} />,
    preranking: <PreRankingPopup sonometer={sonometer!} />,
    texte2: <TextPopup type="texte2" sonometer={sonometer!} />,
    live_sound: <LiveSoundDisplay sonometer={sonometer!} />,
    live_record: <LiveSoundRecord sonometer={sonometer!} />,
    scoreRevelation: (
      <ScoreRevelation
        currentValue={storedAverage ? storedAverage : 0}
        maxRecord={maxAverage ? maxAverage : 0}
        sonometer={sonometer!}
      />
    ),
    animation: <AnimationPopup sonometer={sonometer!} />,
    ranking: <RankingPopup sonometer={sonometer!} />,
    texte3: <TextPopup type="texte3" sonometer={sonometer!} />,
  };

  console.log(" [DISPLAY] Current activeView:", activeView);

  // if (loading) {
  //   return (
  //     <div className="bg-psg-blue flex items-center justify-center h-screen w-screen">
  //       <Loader size="xl" />
  //     </div>
  //   );
  // }

  if (!activeView) {
    return (
      <div
        style={{
          backgroundColor:
            sonometer?.publicScreenSettings?.backgroundColor || "#004070",
          color: sonometer?.publicScreenSettings?.textColor || "#FFFFFF",
        }}
        className="flex items-center justify-center h-screen w-screen"
      >
        <h1 className="text-4xl font-bol font-virage mb-4">
          Waiting for control panel...
        </h1>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor:
          sonometer?.publicScreenSettings?.backgroundColor || "#004070",
        color: sonometer?.publicScreenSettings?.textColor || "#FFFFFF",
      }}
      className="fixed inset-0 flex items-center justify-center"
    >
      <div className="relative">{views[activeView]}</div>
    </div>
  );
};

export default DisplayPage;
